module.exports = __webpack_public_path__ + "img/title-3.d425cc47.png";